import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { BankAccount } from '../../../../../banking/models/bank-account';
import { PaylineAccount } from '../../../../../banking/models/payline-account';
import { PaymentMethodTypeIdEnum } from '../../../../../../models/enum/shared/payment-method-type-id.enum';
import { VariableBenefitPaymentChangeSubmission } from '../../../../../../models/submissions/variable-benefit-payment-change-submission';
import { VariableBenefitPaymentChangeSubmissionData } from '../../../../../../models/submissions/variable-benefit-payment-change-submission-data';

interface DepositCardState {
  isWrittenCheque: boolean;
  bankAccount: BankAccount | null;
  paylineAccount: PaylineAccount | null;
}

@Component({
  selector: 'app-update-vb-payments-deposit-instructions-review-card',
  templateUrl: './update-vb-payments-deposit-instructions-review-card.component.html',
  styleUrls: ['./update-vb-payments-deposit-instructions-review-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateVbPaymentsDepositInstructionsReviewCardComponent implements OnChanges {
  @Input({ required: true }) submission!: VariableBenefitPaymentChangeSubmission;

  public hasChanges = false;
  public currentCard: DepositCardState = this.emptyCardState();
  public newCard: DepositCardState = this.emptyCardState();
  public displayCard: DepositCardState = this.emptyCardState();

  public ngOnChanges(): void {
    const previous = this.submission?.previous ?? null;
    const newData = this.submission?.new ?? null;

    this.currentCard = this.toCardState(previous);
    this.newCard = this.toCardState(newData);
    this.hasChanges =
      previous !== null &&
      newData !== null &&
      (previous.paymentMethodId !== newData.paymentMethodId ||
        previous.bankAccountId !== newData.bankAccountId ||
        previous.paylineAccountId !== newData.paylineAccountId);
    this.displayCard = newData !== null ? this.newCard : this.currentCard;
  }

  private toCardState(data: VariableBenefitPaymentChangeSubmissionData | null): DepositCardState {
    if (data === null) return this.emptyCardState();
    return {
      isWrittenCheque: data.paymentMethodId === PaymentMethodTypeIdEnum.Cheque,
      bankAccount: data.bankAccount,
      paylineAccount: data.paylineAccount
    };
  }

  private emptyCardState(): DepositCardState {
    return { isWrittenCheque: false, bankAccount: null, paylineAccount: null };
  }
}
